export const initialState = {
    periodoInicial: '',
    periodoFinal: '',
    ufDetran: '',
    status: '',
    possuiImagem: '',
    chassi: '',
    numeroContrato: '',
    numeroGravame: '',
    tipoOperacao: '',
    origem: ''
}
